var $4fc5e34bd161c544$exports = {};
// ********** navbar toggle ************
const $4fc5e34bd161c544$var$navBtn = document.getElementById('nav-toggle');
const $4fc5e34bd161c544$var$links = document.getElementById('nav-links');
$4fc5e34bd161c544$var$navBtn.addEventListener('click', ()=>{
    $4fc5e34bd161c544$var$links.classList.toggle('show-links');
});
// ********** set date ************
const $4fc5e34bd161c544$var$date = document.getElementById('date').innerHTML = new Date().getFullYear();
// ********** smooth scroll ************
const $4fc5e34bd161c544$var$scrollLinks = document.querySelectorAll('.scroll-link');
$4fc5e34bd161c544$var$scrollLinks.forEach((link)=>{
    link.addEventListener('click', (e)=>{
        e.preventDefault();
        $4fc5e34bd161c544$var$links.classList.remove('show-links');
        const id = e.target.getAttribute('href').slice(1);
        const element = document.getElementById(id);
        let position = element.offsetTop - 62;
        window.scrollTo({
            left: 0,
            top: position,
            behavior: 'smooth'
        });
    });
});
// ********** toast notification ************
const $4fc5e34bd161c544$var$form = document.querySelector('.contact-form');
const $4fc5e34bd161c544$var$email = document.querySelector('input[name="email"]');
$4fc5e34bd161c544$var$form.addEventListener('submit', function(e) {
    e.preventDefault();
    if ($4fc5e34bd161c544$var$email.value.trim()) {
        Toastify({
            text: 'Your email is successfully submitted',
            style: {
                background: 'rgba(46, 204, 113, 1)'
            }
        }).showToast();
        $4fc5e34bd161c544$var$email.value = '';
    }
});


//# sourceMappingURL=repo.6241e14f.js.map
